export enum CustomerType {
  InsuranceAgents = 'insurance-agents',
  LoanOfficers = 'loan-officers',
  RealEstateAgents = 'real-estate-agents',
  RealEstate = 'realestate', // legacy
}
